SupportFlexibleEmailFormObjectsTemplate = require '../../../../flexible_email_form_objects.html.mustache'
Backbone = require 'backbone'
Backbone.$ = $

class EmailFormIntlCheckboxInputView extends Backbone.View
  tagName: 'li'

  events:
    'change .checkbox_input': 'validate'

  initialize: (options) ->
    @options = options || {}
    @model               = @options.model
    @label               = @model.label
    @I18nScope           = 'modules.support'
    @elementID           = ".checkbox_input"
    @inputInvalidMsgID      = ".inputInvalidMsgID"
    @isFlexibleStepThree = @options.isFlexibleStepThree
    @template            = SupportFlexibleEmailFormObjectsTemplate
    @isInputCompulsory   = @model.required is true or @model.required is "true"

  render: ->
    @$el.html(toHtml(@template, @toHash()))

  toHash: ->
    label         : @label
    required      : @isInputCompulsory
    counter       : @model.counter
    stepThreeType : if @isFlexibleStepThree then 'flexibleStepThree' else 'defaultStepThree'
    checkbox_input_template: true

  isInputGiven: ->
    @isInputValid()

  getInputHtmlElement: ->
    @$el.find(@elementID)

  getInputInvalidHtmlElement: ->
    @$el.find(@inputInvalidMsgID)

  readInput: ->
    _.first(@getInputHtmlElement()).checked

  isInputValid: ->
    if @isInputCompulsory
      return @readInput()
    true

  validateInput: ->
    showInvalidInputMsg = @isInputCompulsory and !@readInput()
    if showInvalidInputMsg
      @getInputInvalidHtmlElement().css('display','block')
    else
      @getInputInvalidHtmlElement().css('display','none')

  validate : () ->
    @validateInput()
    @options.validateEmailForm()

  setCreditRefundBoxSelectedFlag:(data)->
    if window.evaluate(Groupon.Support.ContentModel.isRefundEligible and not(@isInputCompulsory))
      data.credit_refund_check_box_selected = @readInput()

  populateInput: (data)->
    inputData = @readInput()
    @setCreditRefundBoxSelectedFlag(data)
    data.description += "\n\n #{@label} : #{inputData}"

module.exports = EmailFormIntlCheckboxInputView
